import React, { useState } from "react";
import { MoreOutlined } from "@ant-design/icons";
import { Dropdown, DropdownProps, MenuProps } from "antd";
import { MenuItemType } from "antd/es/menu/interface";

export interface items extends MenuItemType {
  closeOnClick?: boolean;
  fakeLink?: boolean;
}

export interface ActionDropdownProps extends DropdownProps {
  items: items[];
}

function ActionsDropdown({ items, ...props }: ActionDropdownProps) {
  const [open, setOpen] = useState(false);

  const handleOpenChange: DropdownProps["onOpenChange"] = (nextOpen, info) => {
    if (info.source === "trigger" || nextOpen) {
      setOpen(nextOpen);
    }
  };

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    const item = items.find((item) => item.key === e.key);
    if (item?.closeOnClick) {
      setOpen(false);
    }
  };

  return (
    <Dropdown
      menu={{
        items: items.map((item) => {
          return {
            ...item,
            label: item.fakeLink ? (
              <div style={{ color: "#1890ff" }}>{item.label}</div>
            ) : (
              item.label
            ),
            icon: item.fakeLink ? <div style={{ color: "#1890ff" }}>{item.icon}</div> : item.icon,
            onClick: handleMenuClick,
          };
        }),
        onClick: () => null,
      }}
      {...props}
      open={open}
      onOpenChange={handleOpenChange}
      trigger={["click"]}
      placement={"bottomRight"}
      arrow={true}
    >
      <MoreOutlined />
    </Dropdown>
  );
}

export default ActionsDropdown;
